// extracted by mini-css-extract-plugin
export var divider = "_3m-0";
export var dividerText = "_3m-2";
export var dividerVertical = "_3m-1";